<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="card">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
            <button pButton pRipple label="{{translations.lbl_send}} {{translations.lbl_file}}"
                icon="pi pi-upload" class="p-button-success p-mr-2" (click)="uploadGuides()"
                *ngIf="!haserrors"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <div class="p-col-12 p-md-6">
            <p-panel>
                <!-- COORDINATION FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12">
                    <!-- INPUT FILE -->
                    <p-fileUpload chooseLabel="Seleccione excel" uploadLabel="Cargar" cancelLabel="Cancelar"
                        name="demo[]" [customUpload]="true" (uploadHandler)="onFileSelect($event)"
                        (onClear)="clearTable()"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                        <ng-template pTemplate="content">
                            <ul *ngIf="uploadedFiles.length">
                                <li *ngFor="let file of uploadedFiles">
                                    <i class="pi pi-file" style="margin-right: 8px;"></i>
                                    {{file.name}} - {{file.size}} bytes
                                </li>
                            </ul>
                        </ng-template>
                    </p-fileUpload>
                </div>
            </p-panel>
        </div>
    </div>

    <br />
    <!-- TAB VIEW -->
     <!-- FORM TRANSFER -->
    <div class="card">
        <!-- TABLE -->
        <p-table #dt1 [value]="listExternGuides" 
             selectionMode="single"
            dataKey="externGuide.id" [rows]="5" [paginator]="true" [rowsPerPageOptions]="[5, 10, 20]"
            [globalFilterFields]="['externGuide.storeId','externGuide.guideId','externGuide.guideName','externGuide.email','externGuide.mobilePhone','externGuide.nationality']"
            [rowHover]="true"
            currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
            [showCurrentPageReport]="true" responsive="true" editMode="row" [expandedRowKeys]="expandedRows">

            <!-- CAPTION -->
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">
                        Derechos de reproducción guías externos
                    </h5>


                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            placeholder="{{translations.lbl_search}}..." />
                    </span>
                </div>

                <span class="p-input-icon-left">

                    <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-mr-2 z-5"
                        (click)="reloadGetListExternGuideDocuments()"></button>
                </span>
            </ng-template>

            <!-- HEADER -->
            <ng-template pTemplate="header">
                <tr>

                    <th  pSortableColumn="externGuide.zone" pTooltip="{{ translations.lbl_zone }}">
                        {{ translations.lbl_zone }} <p-sortIcon field="externGuide.zone"></p-sortIcon>
                    </th>

                    <th  pSortableColumn="externGuide.zone" pTooltip="{{ translations.lbl_national }}">
                        {{ translations.lbl_national }} <p-sortIcon field="externGuide.national"></p-sortIcon>
                    </th>

                    <th  pSortableColumn="externGuide.local" pTooltip="{{ translations.lbl_local }}">
                        {{ translations.lbl_local }} <p-sortIcon field="externGuide.local"></p-sortIcon>
                    </th>

                    <th  pSortableColumn="externGuide.local" pTooltip="{{ translations.lbl_guideId }}">
                        {{ translations.lbl_guideId }} <p-sortIcon field="externGuide.guideId"></p-sortIcon>
                    </th>

                    <th  pSortableColumn="externGuide.cityAddress" pTooltip="{{ translations.lbl_city }}">
                        {{ translations.lbl_city }} <p-sortIcon field="externGuide.cityAddress"></p-sortIcon>
                    </th>

                    <th pSortableColumn="externGuide.guideName" pTooltip="{{ translations.lbl_name }}">
                        {{ translations.lbl_name }} <p-sortIcon field="externGuide.guideName"></p-sortIcon>
                    </th>

                    <th pSortableColumn="externGuide.guideType" pTooltip="{{ translations.lbl_guide }}">
                        {{ translations.lbl_guide }} <p-sortIcon field="externGuide.guideType"></p-sortIcon>
                    </th>

                    

                </tr>
            </ng-template>

            <!-- BODY -->
            <ng-template pTemplate="body" let-data  let-ri="rowIndex">
                <tr [pSelectableRow]="data" [pEditableRow]="data" >
                    <!--pre>{{ data | json }}</pre-->


                    <td 
                        pTooltip="{{ data.externGuide?.zone || (translations.lbl_without + ' ' + translations.lbl_zone ) }}">
                        {{ data.externGuide?.zone || (translations.lbl_without + ' ' + translations.lbl_zone) }}
                    </td>

                    <td 
                        pTooltip="{{ data.externGuide?.national || (translations.lbl_without + ' ' + translations.lbl_zone ) }}">
                        {{ data.externGuide?.national || (translations.lbl_without + ' ' + translations.lbl_zone) }}
                    </td>

                    <td 
                        pTooltip="{{ data.externGuide?.local || (translations.lbl_without + ' ' + translations.lbl_local ) }}">
                        {{ data.externGuide?.local || (translations.lbl_without + ' ' + translations.lbl_local) }}
                    </td>

                    <td 
                        pTooltip="{{ data.externGuide?.cityAddress || (translations.lbl_without + ' ' + translations.lbl_city ) }}">
                        {{ data.externGuide?.cityAddress || (translations.lbl_without + ' ' + translations.lbl_city) }}
                    </td>

                    <td 
                        pTooltip="{{ data.externGuide?.guideId || (translations.lbl_without + ' ' + translations.lbl_guideId) }}">
                        {{ data.externGuide?.guideId || (translations.lbl_without + ' ' + translations.lbl_guideId) }}
                    </td>

                    <td
                        pTooltip="{{ data.externGuide?.guideName || (translations.lbl_without + ' ' + translations.lbl_name) }}">
                        {{ data.externGuide?.guideName || (translations.lbl_without + ' ' + translations.lbl_name) }}
                    </td>

                    <td
                        pTooltip="{{ data.externGuide?.guideType || (translations.lbl_without + ' ' + translations.lbl_guide) }}">
                        {{ data.externGuide?.guideType || (translations.lbl_without + ' ' + translations.lbl_guide) }}
                    </td>

                </tr>

                <!-- SUB TABLE -->
                <tr>
                    <td colspan="1"></td>
                    <td colspan="2" class="sub-table-container">
                        <table class="small-table" responsive="true" >
                            <!-- HEADER SUB TABLE-->
                            <thead>
                                <tr>
                                    <th pTooltip="{{ translations?.lbl_item }}"
                                        data-label="{{ translations?.lbl_item }}">{{
                                        translations.lbl_item }}</th>

                                    <th pTooltip="{{ translations.lbl_description }}"
                                        data-label="{{ translations.lbl_description }}">{{
                                        translations.lbl_description }}</th>

                                    
                                </tr>
                            </thead>

                            <!-- BODY SUB TABLE -->
                            <tbody>
                                <ng-container *ngIf="data.items?.length > 0; else emptyMessage">
                                    <tr *ngFor="let store of data.items" class="p-mb-4">
                                        <!-- ID -->
                                        <td class="align-end" pTooltip="{{ store.itemId || '-' }}"
                                            [attr.data-label]="translations?.lbl_item">
                                            {{ store.itemId || '-' }}
                                        </td>

                                        <!-- Description -->
                                        <td class="align-end" pTooltip="{{ store.descri || '-' }}"
                                            [attr.data-label]="translations?.lbl_description">
                                            {{ store.descri || '-' }}
                                        </td>

                                       
                                    </tr>
                                </ng-container>

                                <!-- EMPTY MESSAGE -->
                                <ng-template #emptyMessage>
                                    <tr>
                                        <td colspan="6" class="text-center">
                                            {{ translations?.lbl_no_records_found }}
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>

                        </table>
                    </td>
                </tr>
            </ng-template>

            <!-- EMPTY -->
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns ? columns.length : 1">
                        {{translations.lbl_no_records_found}}
                    </td>
                </tr>
            </ng-template>

            <!-- SUMMARY -->
            <ng-template pTemplate="summary">
                <div class="p-d-flex">
                    <span class="p-mr-2">{{ translations.lbl_total }}</span>
                    <span class="p-text-bold p-mr-2">
                        {{ listGuidesMedia.length || 0 }}
                    </span>
                    <span>{{ translations.lbl_records }}</span>
                </div>
            </ng-template>

        </p-table>
    </div>
    
</div>